import { AnalyticsDashboard } from "@client/components/analytics/analytics-dashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/stat/")({
	component: RouteComponent,
});

function RouteComponent() {
	return <AnalyticsDashboard />;
}
